/* eslint-disable indent */

    const baggagesObserverMixin = require('../modules/mixins/baggages_observer.mixin');
    const flightChangeFreeUtil = require('../modules/utils/flight_change_free');
    const SidebarSummaryWidget = Odigeo.Widget.extend(baggagesObserverMixin.extend({
        modelClass: require('../modules/models/sidebar_summary.model'),
        viewClass: require('../modules/views/sidebar_summary.view'),
        init: function() {
            this.options = Odigeo.Utils.parseOptions(this.options);
            this.suscribeBaggagesCollectionEvents();
            const {isMembershipFlexibilityD, isPriceWithoutDiscountSelected} = Odigeo.Membership;
            if (isMembershipFlexibilityD && this.options.page !== 'payment' && isPriceWithoutDiscountSelected !== 'true') {
                this.view.renderFlexibility();
            } else {
                this.view.renderFlexAlert();
                if ((Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isPrimeDays) && !isMembershipFlexibilityD) {
                    flightChangeFreeUtil.refreshFlightChangeFreeAirlines(false)
                        .then(this.view.renderFlightChangeAlertWhenAvailable.bind(this.view));
                }
            }
        },
        updatePage: function(page) {
            this.model.updateDataSource(page);
            this.view.onUpdateTravellersName();
            this.view.initializeStickyPrice();
            this.view.showPriceWithoutDiscountSelectedDisclaimer();
        },
        onBaggageLoaded: function() {
            this.view.onUpdateBaggages();
        },
        onBaggageChange: function(changedModel) {
            var selectedAttribute = changedModel.currentOption.get('selected');

            if (selectedAttribute) {
                this.view.onUpdateBaggages();
            }
        },
        onSeatmapChange: function(seatMapCollection) {
            this.model.setSeatMapFromCollection(seatMapCollection);
        },
        updateTravellersName: function(pax) {
            var travellers = $.extend([], this.model.get('paxNameList'));

            travellers[pax.index] = pax.name;

            this.model.set('isSinglePremiumPassengerSelected', (!Odigeo._.isUndefined(pax.id) && pax.id === 0));
            this.model.set('paxNameList', travellers);
            this.view.initializeStickyPrice();
        },
        updatePrices: function(data) {
            this.model.set('price', data);
        },
        updateConcept: function(concept, value) {
            this.model.set(concept, value);
        },
        updateIsPrimeBlocked: function(isPrimeBlocked) {
            this.model.set('isPrimeBlocked', isPrimeBlocked);
        },
        setCcSelected: function(ccName) {
            this.view.setCcSelected(ccName);
        },
        toggleCcType: function(show) {
            this.view.toggleCcType(show);
        },
        setIsUpdatedMembershipPrices: function(isUpdatedMembershipPrices) {
            this.model.set('isUpdatedMembershipPrices', isUpdatedMembershipPrices);
        },
        setPage: function(page) {
            this.model.set('page', page);
        },
        updatePriceMemberDisplay: function(action, isSubscriptionAdded) {
            this.view.updatePriceMemberDisplay(action, isSubscriptionAdded);
        },
        isPriceWithoutDiscountSelected: function() {
            const $cheapestPaymentmethodDisclaimer = this.view.$cachedSelectors.cheapestPaymentmethodDisclaimer;
            return !Odigeo._.isEmpty($cheapestPaymentmethodDisclaimer)
                ? $cheapestPaymentmethodDisclaimer.data('isPriceWithoutDiscountSelected')
                : false;
        },
        updatePriceMemberDisplayPrices: function(action, isSubscriptionAdded) {
            this.view.updatePriceMemberDisplayPrices(action, isSubscriptionAdded);
        },
        refreshPrice: function() {
            this.model.refreshPrice();
        },
        updatePremiumDisclaimers: function(hasToDisplay) {
            this.view.displayPremiumDisclaimers(hasToDisplay);
        },
        updatePremiumSidebarView: function(membershipPerks = {}) {
            var isIncludedInPrice = membershipPerks.isIncludedInPrice;
            if (membershipPerks.isMembershipPriceDisplay) {
                this.view.displayPremiumDisclaimers(isIncludedInPrice);
                this.view.displayPremiumView(isIncludedInPrice && Odigeo._.size(this.model.get('paxNameList')) === 1);
                this.updateBubblePremium({
                    isMemberTestActive: membershipPerks.isMembershipPriceDisplay,
                    isMemberLogged: membershipPerks.isMemberLoggedIn,
                    memberInTravellers: membershipPerks.isIncludedInPrice,
                    membershipPrice: membershipPerks.membershipPrice,
                    isPrimeBlocked: this.model.get('isPrimeBlocked'),
                    isCheapestPriceSelected: membershipPerks.isCheapestPriceSelected,
                    isSubscriptionAdded: membershipPerks.isSubscriptionAdded,
                    isAutoApplyDiscount: membershipPerks.isAutoApplyDiscount,
                });
            }
        },
        updatePricesWithMembershipSubscription: function(membershipPriceItem) {
            this.view.updatePricesWithMembershipSubscription(membershipPriceItem);
        },
        stickPriceSection: function(event) {
            this.view.stickPriceSection(event);
        },
        updateBubblePremium: function(membershipSettings) {
            return this.view.renderPremiumBubble(membershipSettings);
        },
        confirmHotelRemoved: function() {
            this.view.confirmHotelRemoved();
        },
        disableRemoveHotel: function() {
            this.view.disableRemoveHotel();
        },
        enableRemoveHotel: function() {
            this.view.enableRemoveHotel();
        },
        updatePromocode: function(promoCode) {
            this.view.updatePromocode(promoCode);
        },
        togglePriceLoading: function(value) {
            this.view.togglePriceLoading(value);
        },
        refreshSmoothSidebar(params) {
            this.view.updateSmoothPrice(params);
        },
    }));

    Odigeo.defineWidget('sidebar_summary', SidebarSummaryWidget);
